/**
 * A tethered child that kept its spread and left its category group out
 * of order (CU-869ffwfb9).
 *
 * The engine does not cap a child against the consistency ladder — the
 * child exists to hold a spread, and capping it would break the spread
 * the operator set. The price stands, the group ships disordered, and
 * the event says so in `payload.tether_vs_order`: one entry per group
 * broken, naming the nearest offending car by position. Same family as
 * "Floor vs order"; the row says it, which the floor case never did.
 */

const eur = (n) => (n == null ? '—' : `${Number(n).toFixed(2)} €`)
//: "0.88 € " or "" — an entry written before the gap existed still reads.
const gapOf = (e) => (e.gap != null && Number.isFinite(Number(e.gap)) ? `${eur(e.gap)} ` : '')

/** `[{...}]` or `[]` — the entries, whatever shape the row arrived in. */
export function entries(row) {
	const v = row?.payload?.tether_vs_order
	return Array.isArray(v) ? v : []
}

/** The row's sub-label: `out of order vs CDAR` · `out of order vs CDAR, MDAR`. */
export function rowLabel(row) {
	const refs = [...new Set(entries(row).map(e => e.reference_acriss).filter(Boolean))]
	return refs.length ? `out of order vs ${refs.join(', ')}` : null
}

/**
 * One sentence per broken group, for the warning:
 * "kept its tether's −2 % and now sits 0.88 € below CDAR (44.07 €/day) in
 * group AUTO". The gap is the size of the disorder — how far the child
 * would have to move to fall back in line — and the engine writes it.
 */
export function warningLines(row) {
	const delta = row?.via_tether?.delta
	const spread = delta?.k === 'pct'
		? `its tether's ${Number(delta.v) > 0 ? '+' : ''}${Number(delta.v)} %`
		: delta?.v != null ? `its tether's ${Number(delta.v) >= 0 ? '+' : '−'}${eur(Math.abs(Number(delta.v)))}` : 'its spread'
	return entries(row).map(e => ({
		group: e.group_name || e.group_id || '—',
		text: `kept ${spread} and now sits ${gapOf(e)}${e.direction === 'above' ? 'above' : 'below'} ${e.reference_acriss} (${eur(e.reference_price)}/day) in group ${e.group_name || e.group_id || '—'}`,
	}))
}
